(function($) {
	'use strict';

	/**
	 * Extract unique control UIDs for all standards
	 * 
	 * This function processes data to extract unique control UIDs for each
	 * standard ID found in the data. It provides a comprehensive mapping
	 * of all control UIDs organized by standard.
	 * 
	 * @param {Object} data - The data object containing Combined structure
	 * @returns {Object} Object containing unique control UIDs organized by standard ID
	 */
	function extractUniqueControlUIDsForAllStandards(data) {
		// First, extract all unique standard IDs from the data
		const uniqueStandardIDs = WebAssessmentCharts.extractUniqueStandardIDs(data);
		const allControlUIDs = {};

		// Iterate over each unique standard ID
		uniqueStandardIDs.forEach(standardID => {
			// Extract unique control UIDs for each standard ID
			const uniqueControlUIDs = WebAssessmentCharts.extractUniqueControlUIDsForStandard(data, standardID);
			// Store the result in an object with the standard ID as the key
			allControlUIDs[standardID] = uniqueControlUIDs;
		});

		return allControlUIDs;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { extractUniqueControlUIDsForAllStandards };
	} else if (typeof window !== 'undefined') {
		window.extractUniqueControlUIDsForAllStandards = extractUniqueControlUIDsForAllStandards;
	}

})(jQuery);
